import {
  Button,
  ButtonGroup,
  Form,
  FormButton,
  FormField,
  FormSubmitHandler,
  closeCurrentDialog,
} from 'platform/components';
import {VStack} from 'platform/foundation';
import * as Yup from 'yup';

import {useCopyRoleMutation} from '@dms/api/security';
import {CopyRoleRequestBody} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {handleApiError} from '@dms/shared';

type CopyRoleFormProps = {
  sourceRoleId: string;
  onSuccess: () => void;
};

type FormValues = Pick<CopyRoleRequestBody, 'title'>;

export function CopyRoleForm(props: CopyRoleFormProps) {
  const [copyRole] = useCopyRoleMutation();

  const handleSubmit: FormSubmitHandler<FormValues> = async (data) =>
    await copyRole({
      roleId: props.sourceRoleId,
      copyRoleRequestBody: {title: data.title},
    })
      .unwrap()
      .then(() => {
        closeCurrentDialog();
        props.onSuccess();
      })
      .catch(handleApiError);

  return (
    <Form<FormValues> schema={copyRoleSchema} onSubmit={handleSubmit} mode="onSubmit">
      {(control) => (
        <VStack spacing={4}>
          <FormField
            control={control}
            name="title"
            type="text"
            data-testid={testIds.settings.userManagement('copyRoleModalTextField')}
          />

          <ButtonGroup align="right">
            <Button
              onClick={closeCurrentDialog}
              variant="secondary"
              title={i18n.t('general.actions.cancel')}
              data-testid={testIds.settings.userManagement('copyRoleDiscard')}
            />
            <FormButton
              control={control}
              title={i18n.t('general.actions.save')}
              type="submit"
              variant="primary"
              data-testid={testIds.settings.userManagement('copyRoleSubmit')}
            />
          </ButtonGroup>
        </VStack>
      )}
    </Form>
  );
}

const copyRoleSchema = Yup.object().shape({
  title: Yup.string().required(),
});
